import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import { useRef } from 'react'
import emailjs from '@emailjs/browser'
import { ToastContainer, toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'

import { postPushed } from './reducer/postSlice'
import AnimatedLetters from '../AnimatedLetters'

import './index.scss'
import 'react-toastify/dist/ReactToastify.css'

const Contact = () => {
  const [letterClass] = useState('text-animate')

  const [postName, setPostName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')

  const dispatch = useDispatch()
  const posts = useSelector(state => state.posts)
  const form = useRef()
  const contactArray = 'Contact Me'.split('')

  const onPostName = (e) => setPostName(e.target.value)
  const onEmail = (e) => setEmail(e.target.value)
  const onSubject = (e) => setSubject(e.target.value)
  const onMessage = (e) => setMessage(e.target.value)

  const sendEmail = (e) => {
    e.preventDefault()
    dispatch(
      postPushed({
        postName,
        email,
        subject,
        message
      })
    )

    emailjs
      .sendForm(
        process.env.REACT_APP_EMIAL_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        () => {
          // alert('Message successfully sent!')
          toast.success('Message successfully sent!', {
            position: 'bottom-center',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
          })
          const timeout = setTimeout(() => {
            window.location.reload(false)
          }, 3900)

          return () => clearTimeout(timeout)
        },
        () => {
          // alert('Failed to send the message, please try again')
          toast.error('Failed to send the message, please try again', {
            position: 'bottom-center',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
          })
        }
      )
  }
  useEffect(() => {
    function setValue() {
      if(posts.postName) {
        setPostName(posts.postName)
        setEmail(posts.email)
        setSubject(posts.subject)
        setMessage(posts.message)
      }
    }
    setValue()
  })

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={contactArray}
              idx={15}
            />
          </h1>
          <div className='contact-info'>
            <p><b>Telegram</b> : <span>@lukaskelley</span></p>
            <p><b>Skype</b> : <span>live:.cid.718186c50767c3e0</span></p>
            <p><b>email</b> : <span>lukaskelley412@gmail.com</span></p>
            <p><b>Phone Number</b> : <span>+1 (901) 313-8516</span></p>
          </div>
          <div className="contact-form">
            <form>
              <ul>
                <li className="half">
                  <input
                      onChange={onPostName}
                      placeholder="Name"
                      type="text"
                      value={postName}
                      name="name" required />
                </li>
                <li className="half">
                  <input
                    onChange={onEmail}
                    placeholder="Email"
                    type="email"
                    name="email"
                    value={email}
                    required
                  />
                </li>
                <li>
                  <input
                    onChange={onSubject}
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    value={subject}
                    required
                  />
                </li>
                <li>
                  <textarea
                    onChange={onMessage}
                    placeholder="Message"
                    name="message"
                    required
                    value={message}
                  ></textarea>
                </li>
                <li>
                  <button className="flat-button"  onClick={(e) => sendEmail(e)}>Save</button>
                </li>
              </ul>
              <ToastContainer />
            </form>
          </div>
        </div>
        <div className="info-map">
          Lukas Kelley
          <br />
          G3FF+PR Sudbury   <br />
          Greater Sudbury <br />
          ON <br />
          Canada 
          <br />
          
        </div>
        <div className="map-wrap">
          <MapContainer center={[46.524319248082485, -80.92543096779796]} zoom={11}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[46.524319248082485, -80.92543096779796]}>
              <Popup>Lukas lives here :)</Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Contact
